import React, {FC} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {CheckCircleOutline, NotInterested} from "@material-ui/icons";
import {SvgIconProps, Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    active: {
        color: theme.palette.success.main
    },
    inactive: {
        color: theme.palette.warning.main
    }
}))

export const StatusIcon: FC<{active: boolean; iconProps?: SvgIconProps}> = ({active, iconProps}) => {
    const classes = useStyles();
    return active
        ? <CheckCircleOutline {...iconProps} className={classes.active}/>
        : <NotInterested {...iconProps} className={classes.inactive}/>
}

export const StatusDisplay: FC<{ active: boolean }> = ({active}) => (
    <Typography
        variant="inherit"
        color="textSecondary"
        style={{display: 'inline-flex', alignItems: 'center'}}>
        <StatusIcon
            iconProps={{style: {marginRight: 4}}}
            active={active}
        />
        {active ? "Aktiv" : "Deaktiviert"}
    </Typography>
);